// usePublishListContext — index-page hook that publishes live Kendo grid state
// to the page-context bus so the chat widget can overlay it onto the
// server-rendered page context at send time.
//
// Usage (inside a listing feature, e.g. InspectionsIndex):
//
//   const { page, sort, filters, totalCount, data, search } = state;
//   usePublishListContext({ page, sort, filters, totalCount, data, search });
//
// The hook re-publishes whenever the reproducible slice changes and clears the
// bus on unmount (so navigating away doesn't leave a stale listing context for
// a non-listing page — belt-and-suspenders on top of the office MPA full-reload).
import { useEffect } from 'react';
import { publishListContext } from '../services/pageContextBus';
import { listContextFromGridState } from '../services/listContextFromGridState';
export function usePublishListContext(state) {
    var _a, _b, _c, _d, _e;
    // Serialize the inputs we care about so the effect only re-runs on a real
    // change (object identity from the reducer would re-run every render).
    const signature = JSON.stringify({
        page: (_a = state === null || state === void 0 ? void 0 : state.page) !== null && _a !== void 0 ? _a : null,
        sort: (_b = state === null || state === void 0 ? void 0 : state.sort) !== null && _b !== void 0 ? _b : null,
        filters: (_c = state === null || state === void 0 ? void 0 : state.filters) !== null && _c !== void 0 ? _c : null,
        totalCount: (_d = state === null || state === void 0 ? void 0 : state.totalCount) !== null && _d !== void 0 ? _d : null,
        ids: Array.isArray(state === null || state === void 0 ? void 0 : state.data)
            ? state === null || state === void 0 ? void 0 : state.data.map((row) => (row && typeof row.id === 'number' ? row.id : null))
            : null,
        search: (_e = state === null || state === void 0 ? void 0 : state.search) !== null && _e !== void 0 ? _e : null
    });
    useEffect(() => {
        publishListContext(listContextFromGridState(state));
        return () => {
            publishListContext(null);
        };
        // `signature` captures every meaningful change; `state` is intentionally
        // read fresh inside the effect.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signature]);
}
